// @ts-strict-ignore
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UI_STRINGS } from '../../../../functions/language/uistrings';
import { Language } from '../../../../model/enums/language';
import { CustomDialogService } from '../../../../services/custom-dialog-service';
import { TranslationService } from '../../../../services/translation-service';
import { GlobalIcon } from '../icon/icon.constants';
import { InformationDialogType } from '../information-dialog/information-dialog-type';
import { TableService } from './table.service';
import { TableData, TableParentColumn, TableRow, TableRowData } from './types';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    providers: [TableService],
    standalone: false
})
export class TableComponent implements OnInit {
  @Input() caption: string;
  @Input() data: TableData = { rows: [], columns: [] };
  @Input() decimals: number;
  @Input() disabled: boolean = false;
  @Input() leftColumnHeading: boolean;
  @Input() ignoreReadOnly: boolean = false;
  @Input() minWidth: string;
  @Input() showClearTableButton: boolean;
  @Input() showFalseIcon: boolean;
  @Input() summary: string;

  @Output() dataEdited: EventEmitter<{ rows: TableRow[] }> = new EventEmitter();

  editing: boolean = false;
  globalIcons = GlobalIcon;
  isVisible = true;
  lang: Language;

  readonly GLOBAL_STRINGS = UI_STRINGS.GLOBAL;
  readonly STRINGS = UI_STRINGS.COMPONENT_TABLE;

  constructor(
    private _tableService: TableService,
    private _cdr: ChangeDetectorRef,
    private _customDialogService: CustomDialogService,
    private _translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this._tableService.decimals = this.decimals;
    this._tableService.isLeftColumnHeading = this.leftColumnHeading;
    this._tableService.showFalseIcon = this.showFalseIcon;
    this._tableService.data.next(this.data);
    this._tableService.editedRow.subscribe((row) => {
      this.dataEdited.emit(row);
    });
  }

  clearTable() {
    this._customDialogService
      .openDialog({
        title: this._translate(this.GLOBAL_STRINGS.CLEAR_VALUES),
        text: this._translate(this.GLOBAL_STRINGS.CLEAR_TABLE),
        acceptLabel: this._translate(this.GLOBAL_STRINGS.CONTINUE),
        rejectLabel: this._translate(this.GLOBAL_STRINGS.ABORT),
        ignoreReadOnlyRejectButton: true,
        type: InformationDialogType.Info,
      })
      .subscribe((accept) => {
        if (accept) {
          this._tableService.clearTable();
          this._cdr.markForCheck();
        }
      });
  }

  doChildColumnsExist(): boolean {
    return this.data.columns.some((col) => col.children);
  }

  expandAllColumns(): void {
    this.data.columns.map((col) => (col.childrenActive = true));
  }

  onToggleChildren(item: TableParentColumn | TableRow) {
    item.childrenActive = !item.childrenActive;
    /*
     * Below is a force rerender, solving a chrome/edge specific bug:
     * When expanding children some cells are shifted 1px up, causing weird border behaviours.
     * Seems related to cells in first column being sticky.
     *
     * TODO: Investigate further and find other solution; css SHOULD be enough.
     */
    this.isVisible = false;
    this._cdr.detectChanges();
    this.isVisible = true;
  }

  trackByRowId(id: string, data: TableRowData): string {
    return data.id.toString();
  }

  unexpandAllColumns(): void {
    this.data.columns.map((col) => {
      col.childrenActive = false;
    });
  }

  private _translate(stringId: string): string {
    return this._translationService.translate(this.lang, stringId);
  }
}
